module.exports = __webpack_public_path__ + "img/header-engagementRingsClassic@2x.c895560.webp";